import { type MarketTag } from '../domain/MarketTag'

export function formatMarketTagLabel(marketTag: MarketTag) {
  switch (marketTag) {
    case 'contracted':
      return 'Contracted'
    case 'shipperdirect':
      return 'Shipper direct'
    case 'spot':
      return 'Spot'
    default:
      return undefined
  }
}
